<template>
  <header class="app-header navbar" id="app-header">
    <div class="header-left-side">
      <div class="header-left-image noPaddingLeft noPaddingRight" @click="resetSelectedClient()">
        <b-link class="navbar-brand"></b-link>
      </div>
      <div class="header-middle align-center noPaddingLeft noPaddingRight">
        <div class="main-container">
          <div class="fixer-container">
            <div class="display-inline-div custom-multiselect">
              <multiselect v-model="dropdownTitle"
                          :options="getAllClient"
                          placeholder="Choose Client"
                          label="clientName"
                          :openDirection="'below'"
                          :multiple="false"
                          :close-on-select="true"
                          :hide-selected="true"
                          track-by="clientName"
                          :allow-empty="true"
                          :show-labels="false"
                          :disabled="isClientRole"
                          @select="dropdownItemClick">
              </multiselect>
            </div>
          </div>
          <div @click="exportToExcelClick()"
              class="display-inline-div float-right header-icon">
            <Icon name="file-excel-o" class="header-sub-icon"></Icon>
          </div>
        </div>
      </div>
    </div>
    <div class="header-right-text noPaddingRight noPaddingLeft">
      <div class="header-icon" @click="openFaqModal()">
        <Icon name="question-circle-o" class="header-sub-icon"></Icon>
      </div>
      <div class="nameDisplay" @click="isShowUserAction = true" @mouseleave="isShowUserAction = false">
        <div class="header-right-name">{{ userName }}</div>
        <div v-if="!isClientRole" class="header-right-position">{{ userRole }}</div>
        <div v-if="isClientRole" class="header-right-position">{{ clientNameForClient }}</div>
        <div class="user-action-icon">
          <Icon name="sort-down"></Icon>
        </div>
        <div class="user-action-panel" v-if="isShowUserAction">
          <ul>
            <li @click="logout()">Logout</li>
            <li @click="resetPassword()">Change Password</li>
            <li>Email notification: <input type="checkbox" id="switch" v-model="isReceiveEmail"/><label for="switch">Toggle</label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';
  import consts from '../../../_consts';
  import routerConstanst from '@/router/constants';
  import Icon from 'vue-awesome/components/Icon';
  import Multiselect from 'vue-multiselect';
  import Auth from '@aws-amplify/auth';

  import 'vue-awesome/icons/file-excel-o';
  import 'vue-awesome/icons/question-circle-o';
  import 'vue-awesome/icons/sort-down';
  import 'vue-awesome/icons/users';

  export default {
    name: 'c-header',
    components: {
      Icon,
      Multiselect
    },
    props: {},
    data () {
      return {
        dropdownTitle: {},
        isShowUserAction: false,
        isReceiveEmail: true,
        listUserRole: consts.USER_ROLE
      };
    },
    computed: {
      getUserRole () {
        return localStorage.getItem(consts.LOCAL_STORE.role);
      },
      userName () {
        return localStorage.getItem(consts.LOCAL_STORE.userName) || '';
      },
      userRole () {
        return (localStorage.getItem(consts.LOCAL_STORE.role).replace('_', ' ') || '').toLowerCase();
      },
      clientNameForClient () {
        return localStorage.getItem(consts.LOCAL_STORE.clientName);
      },
      isClientRole () {
        return localStorage.getItem(consts.LOCAL_STORE.role) === consts.USER_ROLE.client;
      },
      getAllClient () {
        return this.getClientsName;
      },
      ...mapGetters({
        getClientsName: 'GETTERS_CLIENT_LIST',
        getEmailNotification: 'GETTER_GET_EMAIL_NOTIFICATION'
      })
    },
    methods: {
      sidebarToggle (e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
      },
      sidebarMinimize (e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-minimized');
      },
      mobileSidebarToggle (e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
      },
      asideToggle (e) {
        e.preventDefault();
        document.body.classList.toggle('aside-menu-hidden');
      },
      dropdownItemClick (item) {
        this.selectClient(item);
        this.setListEventStatus('');
        localStorage.setItem(consts.LOCAL_STORE.addOns, item.addOns);
        localStorage.setItem(consts.LOCAL_STORE.readOnly, item.userManageReadOnly);
        localStorage.setItem(consts.LOCAL_STORE.clientId, item.id);
        this.dropdownTitle = {clientName: localStorage.getItem(consts.LOCAL_STORE.clientName) || 'CHOOSE CLIENT'};
        let element = document.querySelector('.animated');
        element.classList.remove('fadeIn');
        setTimeout(() => {
          // this.$router.push(consts.routeDirect.clientDashboard);
          this.$router.push({
            name: routerConstanst.clientDashboard.name,
            params: {
              clientId: item.id
            }
          });
          this.$bus.$emit('resetGetData');
          element.classList.add('fadeIn');
        }, 500);
      },
      logout () { // NOT USE
        Auth.signOut().then(() => {
          console.log('logout');
        }).catch(error => console.log('error', error));
        this.doLogout().then(() => {
          this.disconnetWM();
          return this.$router.go('/login');
        });
      },
      resetPassword () {
        let modalData = {
          action: consts.modalAction.resetPassword,
          data: null
        };
        this.$modal.show('eventModal', modalData);
      },
      resetSelectedClient () {
        if (localStorage.getItem(consts.LOCAL_STORE.role) === consts.USER_ROLE.client) {
          this.$router.push({
            name: routerConstanst.clientDashboard.name,
            params: {
              clientId: localStorage.getItem(consts.LOCAL_STORE.clientId)
            }
          });
        } else {
          localStorage.setItem(consts.LOCAL_STORE.clientId, 0);
          localStorage.setItem(consts.LOCAL_STORE.clientName, 'CHOOSE CLIENT');
          this.dropdownTitle = {clientName: 'CHOOSE CLIENT'};
          this.$router.replace(consts.iconHomeForManager);
        }
      },
      openFaqModal () {
        this.$modal.show('faqModal');
      },
      manageUser () {
        this.$router.replace({
          name: consts.viewNames.managerUsers
        });
      },
      ...mapActions({
        selectClient: 'ACTION_SELECT_CLIENT',
        setListEventStatus: 'ACTION_SET_LIST_EVENT_STATUS',
        exportToExcelClick: 'ACTION_EXPORT_TO_EXCEL',
        doLogout: 'ACTION_DO_LOGOUT',
        getClients: 'ACTION_GET_CLIENTS',
        changeNotification: 'ACTION_CHANGE_NOTIFICATION'
      })
    },
    beforeMount () {
      this.getClients();
      this.dropdownTitle = {clientName: localStorage.getItem(consts.LOCAL_STORE.clientName) || 'CHOOSE CLIENT'};
    },
    mounted () {
      this.isReceiveEmail = this.getEmailNotification;
    },
    watch: {
      isReceiveEmail: {
        handler () {
          this.changeNotification(this.isReceiveEmail);
        }
      }
    }
  };
</script>

<style lang="less">
  @import '../../../styles/variables.less';

  .main-container {
    float: left;
    position: relative;
  }
  .fixer-container {
    float: left;
    position: relative;
    .display-inline-div {
      display: inline-block;
    }
    .float-right {
      float: right;
    }
    .multiselect__option--highlight {
      color: #231F20;
      background-color: #F5F5F5;
    }
  }

  .header-icon {
    float: left;
    height: 25px;
    width: 20px;
    text-align: center;
    margin: 8px 15px;
    &:hover {
      background-color: @grey-5;
      cursor: pointer;
    }
    .header-sub-icon {
      height: 25px;
      width: 20px;
    }
  }

  // if width of screen is smaller than 876, UI will break
  @media screen and (min-width: 764px) {
    .app-header {
      height: 70px;
      .header-left-image {
        max-width: 140px;
        height: 70px;
      }
      .col-md-5 {
        min-width: 400px;
        .header-dropdown {
          width: 220px;
        }
      }
      .col-md-3 {
        max-width: 240px;
        .nameDisplay {
          padding-right: 25px;
        }
      }
    }
  }

  @media screen and (min-width: 720px) and (max-width: 763px) {
    .app-header {
      height: 70px;
      .header-left-image {
        max-width: 140px;
        height: 70px;
      }
      .col-md-5 {
        min-width: 400px;
        .header-dropdown {
          width: 220px;
        }
      }
      .col-md-3 {
        max-width: 198px;
        .nameDisplay {
          padding-right: 25px;
        }
      }
    }
  }

  @media screen and (max-width: 720px) {
    .app-header {
      height: 70px;
      .header-left-image {
        max-width: 140px;
        height: 70px;
      }
      .col-md-5 {
        min-width: 400px;
        .header-dropdown {
          width: 220px;
        }
      }
      .col-md-3 {
        max-width: 190px;
        .nameDisplay {
          padding-right: 25px;
        }
      }
    }
  }

  .header-left-image {
    width: auto;
    min-width: 130px;
    height: 70px;
  }

  .header-dropdown {
    margin-bottom: 12px;
    height: 100px;
    float: left;
  }

  .header-middle {
    width: auto;
    // height: 70px;
    margin-top: 15px;
    display: flex;
    justify-content: center;
  }

  /* FOR CHROME */
  @supports (-webkit-appearance:none) {
    .header-middle-managing {
      height: 29px;
      margin: 6px 10px 4px 0;
      float: left;
    }
  }

  /* FOR IE */
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .header-middle-managing {
      height: 29px;
      width: 10px;
      margin: 6px 130px 4px 0;
      float: left;
    }
    .header-middle-managing-client {
      height: 29px;
      width: 470px;
      margin: 6px 130px 4px 0;
      float: left;
    }
    .header-dropdown {
      width: 250px;
      float: left;
    }
  }

  /* FOR FIREFOX */
  _:-moz-tree-row(hover), .header-middle-managing {
    height: 29px;
    margin: 6px 10px 4px 0;
    float: left;
  }

  .header-middle-text {
    color: @black;
    font-family: @font-family-title;
    font-size: 24px;
    font-weight: bold;
    line-height: 29px;
    text-transform: uppercase;
  }

  .align-center {
    text-align: right;
    // margin: 8px 0 0 0;
    /* FOR FIREFOX */
    _:-moz-tree-row(hover), .dropdown-item, .dropdown-toggle, .dropdown-menu, .b-dropdown {
      width: 240px;
      height: 39px;
    }
    /* FOR CHROME */
    @supports (-webkit-appearance:none) {
      .dropdown-item,
      .dropdown-toggle,
      .dropdown-menu,
      .b-dropdown {
        width: 250px;
        height: 39px;
        float: left;
      }
    }
    /* FOR IE */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      .dropdown-item,
      .dropdown-toggle,
      .dropdown-menu,
      .b-dropdown {
        width: 240px;
        height: 39px;
      }
    }
  }

  .manageText {
    float: right;
    width: 60px;
  }

  .btn-dropdown {
    height: 39px; // width: 218px;
    border: 1px solid @blue;
    border-radius: 3px;
    background-color: @white;
  }

  .btn-group > .btn:first-child {
    background-color: @white;
    color: @black;
    font-family: @font-family-title;
    font-size: 24px;
    font-weight: bold;
    line-height: 29px;
    border: solid 1px @blue;
  }

  .header-right-text {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    // height: 70px;
    margin-top: 5px;
  }

  .nameDisplay {
    padding: 0px 35px 0 0;
    position: relative;
    // min-width: 180px;
    &:hover {
      background-color: @grey-5;
      cursor: pointer;
      .user-action-panel {
        display: block;
      }
    }
    .header-right-position {
      color: @grey-2;
      font-family: 'Open Sans', sans-serif;
      font-size: 12px;
      line-height: 20px;
      text-align: right;
      width: 100px;
      text-transform: capitalize;
    }
    .user-action-icon {
      position: absolute;
      right: 10px;
      top: 15px;
    }
    .user-action-panel {
      position: absolute;
      right: 0;
      z-index: 999;
      top: 44px;
      background-color: @white;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
      border-radius: 2px;
      ul {
        width: 250px;
        list-style: none;
        padding-left: 0;
        margin-bottom: 0;
        li {
          height: 35px;
          width: 100%;
          text-align: left;
          margin: 10px 0;
          line-height: 35px;
          padding-left: 10px;
          color: @black;
          &:hover {
            background-color: @grey-5;
            cursor: pointer;
          }

          input[type=checkbox] {
            height: 0;
            width: 0;
            visibility: hidden;
          }

          label {
            cursor: pointer;
            text-indent: -9999px;
            width: 30px;
            height: 15px;
            background: grey;
            border-radius: 15px;
            position: relative;
            top: 11px;
            left: 5px;
          }

          label:after {
            content: '';
            position: absolute;
            top: 1px;
            left: 1px;
            width: 15px;
            height: 13px;
            background: #fff;
            border-radius: 15px;
            transition: 0.3s;
          }

          input:checked + label {
            background: #0080A5;
          }

          input:checked + label:after {
            left: calc(100% - 5px);
            transform: translateX(-100%);
          }

          label:active:after {
            width: 15px;
          }
        }
      }
    }
  }

  .header-right-name {
    color: @black;
    font-family: @font-family-main;
    font-size: 14px;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100px;
  }

  .dropdown-menu {
    border: none;
  }

  .btn .dropdown-toggle .btn-secondary {
    padding: 7px 5px 0 7px;
    color: @black;

  }

  .b-dropdown .dropdown-item:focus {
    box-shadow: none;
  }

  .b-dropdown .dropdown-item:hover {
    box-shadow: inset 0 0 400px 110px @grey-5;
    background-color: @grey-5;
  }

  .dropdown-item {
    background-color: @white !important;
    color: @black !important;
    box-sizing: border-box;
    font-family: @font-family-main;
    border: none;
    padding: 0;
    &:focus {
      outline: none;
    }
  }

  .btn-group > .btn:first-child {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 10px;
    text-align: left;
  }

  .header-dropdown-items > .dropdown-item:first-child {
    margin-top: 7px;
  }

  .header-dropdown-items > .dropdown-item:last-child > .wrapper-item {
    border-bottom: none;
  }

  .header-dropdown-items {
    max-height: 203px;
    overflow-y: scroll;
    width: 250px;
    min-width: 220px;
    border-radius: 3px;
    margin: -2px 0 0 0;
    border: 1px solid @grey-4;
    padding-bottom: 7px;
    background-color: #fff;
    .dropdown-item-sub {
      .wrapper-item {
        border-bottom: 1px solid @grey-5;
        // width: 100%;
        height: 100%;
        margin: 0 0 0 10px;
        padding: 10px 0 0 10px;
        font-family: @font-family-main;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

  .app-header.navbar {
    padding-right: 0;
    height: 70px;
    .navbar-brand {
      width: 140px;
      height: 69px;
      padding: unset;
      margin-right: unset;
      border-bottom: none;
      background-size: cover;
    }
    .dropdown-item {
      width: 100%;
    }
  }

  .header-middle-export-to-excel-text {
    height: 28px;
    // width: 100px;
    color: @blue;
    font-family: @font-family-main;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    display: inline-block;
    margin-left: 10px;
    margin-top: 6px;
    float: left;
    text-align: left;
    &:hover {
      cursor: pointer;
    }
  }

  .btn-logout {
    font-family: @font-family-main;
    background-color: @white;
    color: @blue;
    height: 40px;
    border-color: @blue;
    float: right;
  }

  .dropdown-toggle::after {
    margin-top: 7px;
    position: absolute;
    right: 5px;
    top: 10px;
    color: @blue;
  }

  .nav-link, .navbar .dropdown-toggle {
    padding: 5px 0 0 10px;
  }


</style>



// WEBPACK FOOTER //
// Header.vue?48f81ece